module.exports = __webpack_public_path__ + "static/media/patrol(16).0b9a44bd.PNG";